import script from "./EventTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./EventTimeline.vue?vue&type=script&setup=true&lang=js"

import "./EventTimeline.vue?vue&type=style&index=0&id=0108a90e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0108a90e"]])

export default __exports__